import React from 'react'
import { LoadingImgIcon } from '../../assets/icons';

function MainStandardLoader() {
  return (
    <div className=' h-48 md:h-36 w-[100%] border flex flex-col items-center justify-center border-borderdark rounded-xl py-2 m-auto animate-pulse gap-y-3'>
        <div className=' flex items-center justify-center w-[70%] h-44 md:h-32 bg-gray-100 rounded'>
            <LoadingImgIcon/>
        </div>
        <div className="h-3 bg-gray-100 rounded-full md:w-32"></div>
    </div>
  )
}

export default MainStandardLoader;